import React from "react";
import { Grid, Typography, FormControl, InputLabel, Select, MenuItem, Box, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ImArrowDown } from "react-icons/im";

const RootCausesFamilies = (props) => {
    const { t } = useTranslation();
    const theme = useTheme();
    return (
        <Grid container xs={12} sm={5} md={5}>
            <Box
                sx={{
                    width: "98%",
                    px: 1,
                    py: 1,
                    m: 1,
                    mt: 0,
                    alignItems: "center",
                    backgroundColor: theme.palette.grey[100],
                    borderRadius: "12px",
                    boxShadow: 3,
                    gap: 2
                }}
            >
                <Grid item xs={12} sm={12}>
                    <Typography variant="h6" align="center" sx={{ fontSize: 15, fontWeight: "bold", backgroundColor: "#DEE0E0" }}>
                        {t("RootCausesFamilies")}
                    </Typography>
                </Grid>
                {/* DETERIORATION, EXCESSIVE STRESS, INSUFFICIENT STRENGHT */}
                <Grid container xs={12} sm={12}>
                    <Grid item xs={4} sm={4} md={4} sx={{ display: "grid", alignContent: "center", paddingTop: 1, paddingLeft: 1 }}>
                        <Typography variant="h6" align="center" sx={{ fontSize: 12, border: 2, borderRadius: 2 }}>
                            {t("Deterioration")}
                        </Typography>
                    </Grid>
                    <Grid item xs={4} sm={4} md={4} sx={{ display: "grid", alignContent: "center", paddingTop: 1 }}>
                        <Typography variant="h6" align="center" sx={{ fontSize: 12, border: 1, borderRadius: 2, margin: 1 }}>
                            {t("ExcessiveStress")}
                        </Typography>
                    </Grid>
                    <Grid item xs={4} sm={4} md={4} sx={{ display: "grid", alignContent: "center", paddingTop: 1, paddingRight: 1 }}>
                        <Typography variant="h6" align="center" sx={{ fontSize: 12, border: 2, borderRadius: 2, borderStyle: "dotted" }}>
                            {t("InsufficientStrenght")}
                        </Typography>
                    </Grid>
                </Grid>
                <Grid container xs={12} sm={12}>
                    <Grid item xs={12} sm={12} md={12} sx={{ margin: 1, marginBottom: 0 }}>
                        <img id="rc_arrows" alt="Upload" style={{ width: "91%", height: "auto" }} src={require("../../assets/arrows_5.png")} />
                    </Grid>
                </Grid>
                <Grid container xs={12} sm={12}>
                    <Grid item xs={2} sm={2} md={2} sx={{ display: "flex", alignContent: "center", padding: 1, paddingTop: 0 }}>
                        <Typography variant="h6" sx={{ display: "flex", alignItems: "center", fontSize: 10, border: 2, borderBottomStyle: "dotted", minHeight: 50 }}>
                            {t("LackOfBasicConditions")}
                        </Typography>
                    </Grid>
                    <Grid item xs={2} sm={2} md={2} sx={{ display: "flex", alignContent: "center", padding: 1, paddingTop: 0 }}>
                        <Typography variant="h6" sx={{ display: "flex", alignItems: "center", fontSize: 10, border: 2, borderBottomStyle: "dotted", minHeight: 50 }}>
                            {t("FailureToRespect")}
                        </Typography>
                    </Grid>
                    <Grid item xs={2} sm={2} md={2} sx={{ display: "flex", alignContent: "center", padding: 1, paddingTop: 0 }}>
                        <Typography variant="h6" sx={{ display: "flex", alignItems: "center", fontSize: 9, border: 2, borderBottomStyle: "dotted", minHeight: 50 }}>
                            {t("LackOfMaintenance")}
                        </Typography>
                    </Grid>
                    <Grid item xs={2} sm={2} md={2} sx={{ display: "flex", alignContent: "center", padding: 1, paddingTop: 0 }}>
                        <Typography variant="h6" sx={{ display: "flex", alignItems: "center", fontSize: 10, border: 2, borderBottomStyle: "dotted", minHeight: 50 }}>
                            {t("InsufficientSkills")}
                        </Typography>
                    </Grid>
                    <Grid item xs={2} sm={2} md={2} sx={{ display: "flex", alignContent: "center", padding: 1, paddingTop: 0 }}>
                        <Typography variant="h6" sx={{ display: "flex", alignItems: "center", fontSize: 10, border: 2, borderBottomStyle: "dotted", minHeight: 50 }}>
                            {t("DesignWeaknesses")}
                        </Typography>
                    </Grid>
                    <Grid item xs={2} sm={2} md={2} sx={{ display: "flex", alignContent: "center", padding: 1, paddingTop: 0 }}>
                        <Typography variant="h6" sx={{ display: "flex", alignItems: "center", fontSize: 10, border: 2, borderBottomStyle: "dotted", minHeight: 50 }}>
                            {t("ExternalInfluences")}
                        </Typography>
                    </Grid>
                    <Grid item xs={2} sm={2} md={2} sx={{ justifyItems: "center" }}>
                        <ImArrowDown />
                    </Grid>
                    <Grid item xs={2} sm={2} md={2} sx={{ justifyItems: "center", justifyContent: "center" }}>
                        <ImArrowDown />
                    </Grid>
                    <Grid item xs={2} sm={2} md={2} sx={{ justifyItems: "center" }}>
                        <ImArrowDown />
                    </Grid>
                    <Grid item xs={2} sm={2} md={2} sx={{ justifyItems: "center" }}>
                        <ImArrowDown />
                    </Grid>
                    <Grid item xs={2} sm={2} md={2} sx={{ justifyItems: "center" }}>
                        <ImArrowDown />
                    </Grid>
                    <Grid item xs={2} sm={2} md={2} sx={{ justifyItems: "center" }}>
                        <ImArrowDown />
                    </Grid>
                    <Grid item xs={2} sm={2} md={2} sx={{ display: "grid", alignContent: "center", paddingLeft: 1 }}>
                        <FormControl size="small" fullWidth>
                            <InputLabel>Select</InputLabel>
                            <Select
                                label="Select"
                                disabled={
                                    props.fromPage === "operator" ||
                                    props.selectedFailureToRespect !== 0 ||
                                    props.selectedLackOfMaintenance !== 0 ||
                                    props.selectedInsufficientSkills !== 0 ||
                                    props.selectedDesignWeaknesses !== 0 ||
                                    props.selectedExternalInfluences !== 0
                                }
                                value={props.selectedLackOfCondition}
                                onChange={props.handleLackOfConditionChaged}
                                error={
                                    props.fromPage !== "operator" &&
                                    props.selectedDesignWeaknesses === 0 &&
                                    props.selectedLackOfCondition === 0 &&
                                    props.selectedLackOfMaintenance === 0 &&
                                    props.selectedInsufficientSkills === 0 &&
                                    props.selectedFailureToRespect === 0 &&
                                    props.selectedExternalInfluences === 0
                                }
                            >
                                <MenuItem value={0}>{t("None")}</MenuItem>
                                {props.lackOfBasicConditions.map((option) => (
                                    <MenuItem key={option.id} value={option.id}>
                                        {t(`LackOfBasicConditionsItems.${option.options}`)}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={2} sm={2} md={2} sx={{ display: "grid", alignContent: "center", paddingLeft: 1 }}>
                        <FormControl size="small" fullWidth>
                            <InputLabel>Select</InputLabel>
                            <Select
                                label="Select"
                                disabled={
                                    props.fromPage === "operator" ||
                                    props.selectedLackOfCondition !== 0 ||
                                    props.selectedLackOfMaintenance !== 0 ||
                                    props.selectedInsufficientSkills !== 0 ||
                                    props.selectedDesignWeaknesses !== 0 ||
                                    props.selectedExternalInfluences !== 0
                                }
                                value={props.selectedFailureToRespect}
                                onChange={props.handleFailuretoRespectChaged}
                                error={
                                    props.fromPage !== "operator" &&
                                    props.selectedDesignWeaknesses === 0 &&
                                    props.selectedLackOfCondition === 0 &&
                                    props.selectedLackOfMaintenance === 0 &&
                                    props.selectedInsufficientSkills === 0 &&
                                    props.selectedFailureToRespect === 0 &&
                                    props.selectedExternalInfluences === 0
                                }
                            >
                                <MenuItem value={0}>{t("None")}</MenuItem>
                                {props.failureToRespect.map((option) => (
                                    <MenuItem key={option.id} value={option.id}>
                                        {t(`FailureToRespectItems.${option.options}`)}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={2} sm={2} md={2} sx={{ display: "grid", alignContent: "center", paddingLeft: 1 }}>
                        <FormControl size="small" fullWidth>
                            <InputLabel>Select</InputLabel>
                            <Select
                                label="Select"
                                disabled={
                                    props.fromPage === "operator" ||
                                    props.selectedLackOfCondition !== 0 ||
                                    props.selectedFailureToRespect !== 0 ||
                                    props.selectedInsufficientSkills !== 0 ||
                                    props.selectedDesignWeaknesses !== 0 ||
                                    props.selectedExternalInfluences !== 0
                                }
                                value={props.selectedLackOfMaintenance}
                                onChange={props.handleLackOfMaintenanceChaged}
                                error={
                                    props.fromPage !== "operator" &&
                                    props.selectedDesignWeaknesses === 0 &&
                                    props.selectedLackOfCondition === 0 &&
                                    props.selectedLackOfMaintenance === 0 &&
                                    props.selectedInsufficientSkills === 0 &&
                                    props.selectedFailureToRespect === 0 &&
                                    props.selectedExternalInfluences === 0
                                }
                            >
                                <MenuItem value={0}>{t("None")}</MenuItem>
                                {props.lackOfMaintenance.map((option) => (
                                    <MenuItem key={option.id} value={option.id}>
                                        {t(`LackOfMaintenanceItems.${option.options}`)}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={2} sm={2} md={2} sx={{ display: "grid", alignContent: "center", paddingLeft: 1 }}>
                        <FormControl size="small" fullWidth>
                            <InputLabel>Select</InputLabel>
                            <Select
                                label="Select"
                                disabled={
                                    props.fromPage === "operator" ||
                                    props.selectedLackOfCondition !== 0 ||
                                    props.selectedFailureToRespect !== 0 ||
                                    props.selectedLackOfMaintenance !== 0 ||
                                    props.selectedDesignWeaknesses !== 0 ||
                                    props.selectedExternalInfluences !== 0
                                }
                                value={props.selectedInsufficientSkills}
                                onChange={props.handleInsufficientSkillsChaged}
                                error={
                                    props.fromPage !== "operator" &&
                                    props.selectedDesignWeaknesses === 0 &&
                                    props.selectedLackOfCondition === 0 &&
                                    props.selectedLackOfMaintenance === 0 &&
                                    props.selectedInsufficientSkills === 0 &&
                                    props.selectedFailureToRespect === 0 &&
                                    props.selectedExternalInfluences === 0
                                }
                            >
                                <MenuItem value={0}>{t("None")}</MenuItem>
                                {props.insufficientSkills.map((option) => (
                                    <MenuItem key={option.id} value={option.id}>
                                        {t(`InsufficientSkillsItems.${option.options}`)}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={2} sm={2} md={2} sx={{ display: "grid", alignContent: "center", paddingLeft: 1 }}>
                        <FormControl size="small" fullWidth>
                            <InputLabel>Select</InputLabel>
                            <Select
                                label="Select"
                                disabled={
                                    props.fromPage === "operator" ||
                                    props.selectedLackOfCondition !== 0 ||
                                    props.selectedFailureToRespect !== 0 ||
                                    props.selectedLackOfMaintenance !== 0 ||
                                    props.selectedInsufficientSkills !== 0 ||
                                    props.selectedExternalInfluences !== 0
                                }
                                value={props.selectedDesignWeaknesses}
                                onChange={props.handleDesignWeaknessesChaged}
                                error={
                                    props.fromPage !== "operator" &&
                                    props.selectedDesignWeaknesses === 0 &&
                                    props.selectedLackOfCondition === 0 &&
                                    props.selectedLackOfMaintenance === 0 &&
                                    props.selectedInsufficientSkills === 0 &&
                                    props.selectedFailureToRespect === 0 &&
                                    props.selectedExternalInfluences === 0
                                }
                            >
                                <MenuItem value={0}>{t("None")}</MenuItem>
                                {props.designWeaknesses.map((option) => (
                                    <MenuItem key={option.id} value={option.id}>
                                         {t(`DesignWeaknessesItems.${option.options}`)}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={2} sm={2} md={2} sx={{ display: "grid", alignContent: "center", paddingLeft: 1, paddingRight: 1 }}>
                        <FormControl size="small" fullWidth>
                            <InputLabel>Select</InputLabel>
                            <Select
                                label="Select"
                                disabled={
                                    props.fromPage === "operator" ||
                                    props.selectedLackOfCondition !== 0 ||
                                    props.selectedFailureToRespect !== 0 ||
                                    props.selectedLackOfMaintenance !== 0 ||
                                    props.selectedInsufficientSkills !== 0 ||
                                    props.selectedDesignWeaknesses !== 0
                                }
                                value={props.selectedExternalInfluences}
                                onChange={props.handleExternalInfluencesChaged}
                                error={
                                    props.fromPage !== "operator" &&
                                    props.selectedDesignWeaknesses === 0 &&
                                    props.selectedLackOfCondition === 0 &&
                                    props.selectedLackOfMaintenance === 0 &&
                                    props.selectedInsufficientSkills === 0 &&
                                    props.selectedFailureToRespect === 0 &&
                                    props.selectedExternalInfluences === 0
                                }
                            >
                                <MenuItem value={0}>{t("None")}</MenuItem>
                                {props.externalInfluences.map((option) => (
                                    <MenuItem key={option.id} value={option.id}>
                                        {t(`ExternalInfluencesItems.${option.options}`)}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid container xs={12} sm={12}>
                    <Grid item xs={12} sm={12} md={12} sx={{ margin: 1, marginBottom: 0 }}>
                        <img id="fu_img" alt="Upload" style={{ width: "100%", height: "115%" }} src={require("../../assets/d6.png")} />
                    </Grid>
                </Grid>
            </Box>
        </Grid>
    );
};

export default RootCausesFamilies;
